<div style="width: 100px;">
  @if (!games().length) {
    <span class="percentage d-block">
      {{ 0 | number : '1.0-0' : 'en' }}%
    </span>
    <mat-progress-bar
      mode="determinate"
      [value]="0 | number : '1.0-0' : 'en'"
    ></mat-progress-bar>
  } @else {
    <span class="percentage d-block">
      {{ ((playedGames().length / games().length) * 100) | number : '1.0-0' : 'en' }}%
    </span>
    <mat-progress-bar
      mode="determinate"
      [value]="((playedGames().length / games().length) * 100) | number : '1.0-0' : 'en'"
    ></mat-progress-bar>
  }
</div>
